import React, { FC } from 'react'

export type CheckboxValue = string | number | readonly string[]

interface Props {
  className?: string
  value: CheckboxValue | undefined
  onClick: (arg0: CheckboxValue) => void
  options: { value: CheckboxValue; label: string }[]
}

const InputGroup: FC<Props> = ({ options, value, onClick, ...props }) => {
  return (
    <div {...props}>
      {options.map((option, index: number) => {
        const uniqueId = `${option.label}-${index}`
        return (
          <span key={uniqueId} className="FormButtonGroup-button">
            <input
              id={uniqueId}
              type="checkbox"
              value={option.value}
              className="FormButtonGroup-input"
              checked={value === option.value}
              onChange={() => onClick(option.value)}
            />
            <label htmlFor={uniqueId} data-testid={uniqueId} className="font-circular-book FormButtonGroup-label">
              {option.label}
            </label>
          </span>
        )
      })}
    </div>
  )
}

export default InputGroup
